import * as React from 'react';

import EnterpriseOrgProductFeaturesDataProvider from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgProductFeaturesDataProvider';
import EnterpriseThirdPartyOrgDataProvider from 'bundles/unified-common/providers/org-scoped/data/EnterpriseThirdPartyOrgDataProvider';

const EnterpriseOrgScopedPageDataProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseThirdPartyOrgDataProvider>
      <EnterpriseOrgProductFeaturesDataProvider>{children}</EnterpriseOrgProductFeaturesDataProvider>
    </EnterpriseThirdPartyOrgDataProvider>
  );
};

export default EnterpriseOrgScopedPageDataProvider;
